import { palette } from '@dev/ee-components';
import styled from 'styled-components';

export const Step4EditContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const Step4EditContentColumns = styled.div`
    display: grid;
    grid-template-columns: 1fr minmax(0, 1fr);
    gap: 24px;
`;

export const InputLength = styled.span`
    grid-area: d;
    display: flex;
    justify-content: end;
    color: ${palette.gray[5]};
    font-size: 14px;
`;

export const InputFieldWrapper = styled.div`
    margin-top: 16px;               
    grid-area: c;
    textarea {
        max-width: 100%;
        width: 100%;
        margin-bottom: 0;
    }
`;
